// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_4a-6";
export var headerCell = "_4a-2";
export var rowWrapper = "_4a-4";
export var stickyAggregationCell = "_4a-a";
export var stickyAggregationRow = "_4a-7";
export var stickyColumnCell = "_4a-9";
export var stickyColumnHeaderCell = "_4a-8";
export var table = "_4a-1";
export var virtualRowWrapper = "_4a-5";
export var virtualTableContainer = "_4a-0";
export var white = "_4a-3";